import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const ContentWrapper = styled(Grid)`
  cursor: pointer;
`;
